<template>
  <div
    class="flex w-full items-center justify-center py-16"
    v-if="modalIsLoading"
  >
    <i v-html="$icons.loading" class="text-ontick-blue-600"></i>
    <span class="sr-only">Carregando</span>
  </div>
  <div v-else class="divide-ontick-steel-500 flex flex-col divide-y text-sm">
    <dl class="flex flex-col py-4">
      <dt class="text-base font-bold">
        {{ modalData.alg_ord_name }}
      </dt>
      <dd class="text-xs">{{ modalData.alg_ord_description }}</dd>
    </dl>
    <div class="flex flex-col gap-6 py-4">
      <div class="flex items-center justify-between gap-4">
        <dl class="flex flex-col">
          <dt>Par</dt>
          <dd>
            {{ modalData.alg_ord_symbol_1 }} |
            {{ modalData.alg_ord_symbol_2 }}
          </dd>
        </dl>
        <dl class="flex flex-col">
          <dt>Tipo de operação</dt>
          <dd class="text-ontick-yellow-800 font-bold uppercase">
            {{ direction }}
          </dd>
        </dl>
        <dl class="flex flex-col">
          <dt>Tipo do volume</dt>
          <dd>{{ volumeType }}</dd>
        </dl>
        <dl class="flex flex-col">
          <dt class="">Origem</dt>
          <dd>{{ visibility }}</dd>
        </dl>
      </div>
      <div
        class="divide-ontick-steel-300 dark:divide-ontick-steel-500 grid grid-cols-2 gap-4 divide-x-2"
      >
        <div class="flex flex-col gap-2 pr-4">
          <div>
            <span class="symbol">
              {{ detailsSymbols.symbols.symbol_1.symbol_name }}
            </span>
          </div>
          <div class="flex items-center justify-between">
            <dl class="flex flex-col">
              <dt>Vol. total</dt>
              <dd>{{ detailsSymbols.symbols.symbol_1.total_volume }}</dd>
            </dl>
            <dl class="flex flex-col">
              <dt>Vol. executado</dt>
              <dd>{{ detailsSymbols.symbols.symbol_1.current_volume }}</dd>
            </dl>
          </div>
        </div>
        <div class="flex flex-col gap-2 pl-4">
          <div>
            <span class="symbol">
              {{ detailsSymbols.symbols.symbol_2.symbol_name }}
            </span>
          </div>
          <div class="flex items-center justify-between">
            <dl class="flex flex-col">
              <dt>Vol. total</dt>
              <dd>{{ detailsSymbols.symbols.symbol_2.total_volume }}</dd>
            </dl>
            <dl class="flex flex-col">
              <dt>Vol. executado</dt>
              <dd>{{ detailsSymbols.symbols.symbol_1.current_volume }}</dd>
            </dl>
          </div>
        </div>
      </div>
      <template v-if="method === 'Função linear'">
        <div class="flex items-center justify-between gap-4">
          <dl class="flex flex-col">
            <dt>Método</dt>
            <dd>{{ method }}</dd>
          </dl>

          <dl class="flex flex-col" v-if="modalData.alg_ord_intercept">
            <dt>Intercepto</dt>
            <dd>{{ modalData.alg_ord_intercept || "---" }}</dd>
          </dl>
          <dl class="flex flex-col" v-if="modalData.alg_ord_slope">
            <dt>Coeficiente angular</dt>
            <dd>{{ modalData.alg_ord_slope || "---" }}</dd>
          </dl>
        </div>
        <div class="flex items-center justify-between gap-4">
          <dl class="flex flex-col">
            <dt>Entrada</dt>
            <dd>{{ modalData.alg_ord_entry || "---" }}</dd>
          </dl>

          <dl class="flex flex-col">
            <dt>Take profit</dt>
            <dd>
              {{ modalData.alg_ord_tp || "---" }}
              <span v-if="modalData.tp_sl_calc_type === 'PERCENT'">%</span>
            </dd>
          </dl>
          <dl class="flex flex-col">
            <dt>Stop loss</dt>
            <dd>
              {{ modalData.alg_ord_sl || "---" }}
              <span v-if="modalData.tp_sl_calc_type === 'PERCENT'">%</span>
            </dd>
          </dl>
        </div>
      </template>
      <div class="flex items-center justify-between gap-4" v-else>
        <dl class="flex flex-col">
          <dt>Método</dt>
          <dd>{{ method }}</dd>
        </dl>
        <dl class="flex flex-col">
          <dt>Entrada</dt>
          <dd>{{ modalData.alg_ord_entry || "---" }}</dd>
        </dl>

        <dl class="flex flex-col">
          <dt>Take profit</dt>
          <dd>
            {{ modalData.alg_ord_tp || "---" }}
            <span v-if="modalData.tp_sl_calc_type === 'PERCENT'">%</span>
          </dd>
        </dl>
        <dl class="flex flex-col">
          <dt>Stop loss</dt>
          <dd>
            {{ modalData.alg_ord_sl || "---" }}
            <span v-if="modalData.tp_sl_calc_type === 'PERCENT'">%</span>
          </dd>
        </dl>
      </div>
      <div class="grid grid-cols-2 gap-4">
        <dl class="flex flex-col">
          <dt>Horário inicial</dt>
          <dd>
            {{
              (modalData.alg_ord_user_start_datetime &&
                this.moment(modalData.alg_ord_user_start_datetime).format(
                  "DD/MM/YYYY HH:mm:ss"
                )) ||
              "---"
            }}
          </dd>
        </dl>
        <dl class="flex flex-col">
          <dt>Horário final</dt>
          <dd>
            {{
              (modalData.alg_ord_user_end_datetime &&
                this.moment(modalData.alg_ord_user_end_datetime).format(
                  "DD/MM/YYYY HH:mm:ss"
                )) ||
              "---"
            }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["modalData", "modalIsLoading", "detailsSymbols"],

  computed: {
    method() {
      switch (this.modalData.alg_ord_calc_type) {
        case "FACTOR":
          return "Fator";
        case "DIFFERENCE":
          return "Diferença";
        case "LINEAR_FUNCTION":
          return "Função linear";
        default:
          return this.modalData.alg_ord_calc_type;
      }
    },
    direction() {
      switch (this.modalData.alg_ord_direction) {
        case "BUY":
          return "Compra";
        case "SELL":
          return "Venda";

        default:
          return this.modalData.alg_ord_direction;
      }
    },
    volumeType() {
      switch (this.modalData.alg_ord_volume_type) {
        case "FIN_VOLUME":
          return "Financeiro";
        case "QUANTITY":
          return "Quantidade";

        default:
          return this.modalData.alg_ord_volume_type;
      }
    },
    visibility() {
      if (
        !!this.modalData.alg_ord_code ||
        this.modalData.alg_ord_visibility !== "PRIVATE"
      ) {
        return "Pública";
      }
      return "Privada";
    },
  },
};
</script>

<style lang="scss" scoped>
dt {
  @apply text-gray-500 dark:text-gray-400;
}
.symbol {
  @apply bg-ontick-blue-900 dark:text-ontick-blue-500 rounded px-3 py-1 text-xs text-gray-50;
}
</style>
